<!-- src/views/HomePage.vue -->
<template>
  <div>
    <!-- Check if the user is authenticated -->
    <div v-if="isAuthenticated">
      <!-- Authenticated Content -->

      <!-- Current Conditions Component -->
      <current-conditions :site="selectedSite" />

      <!-- Hint Snackbar Component -->
      <hint-snackbar />
      <!-- Disclaimer Component -->
      <disclaimer-component />
      <v-container class="border border-primary bg-white">
        <v-alert outlined color="transparent" class="text-primary">
          <b>Cawthron Buoy Network ✨ Preview ✨</b>
          <br />
          Funded by MBIE<br />
          Project: Ngā Punga o Te Moana - Anchoring our Open Ocean Aquaculture
          Future
        </v-alert>
      </v-container>
      <!-- Partner Logos Component -->
      <partner-logos />
    </div>

    <div v-else>
      <!-- Unauthenticated Content (Welcome Page) -->
      <welcome-page />
    </div>
  </div>
</template>

<script>
import { useAuth0 } from "@auth0/auth0-vue";
import CurrentConditions from "../components/currentConditions.vue";
import DisclaimerComponent from "../components/disclaimerComponent.vue";
import HintSnackbar from "../components/hintSnackbar.vue";
import PartnerLogos from "../components/partnerLogos.vue";
import WelcomePage from "../components/WelcomePage.vue";

export default {
  name: "HomePage",
  components: {
    CurrentConditions,
    DisclaimerComponent,
    HintSnackbar,
    PartnerLogos,
    WelcomePage,
  },
  data() {
    return {
      selectedSite: "Tasman Bay", // Default site
    };
  },
  setup() {
    const { isAuthenticated } = useAuth0();

    return {
      isAuthenticated,
    };
  },
  watch: {
    isAuthenticated(newVal) {
      if (newVal) {
        // User just authenticated, set the default site
        this.selectedSite = "Tasman Bay";
        // dispatch to Vuex store to set the site
        this.$store.dispatch("setSite", "Tasman Bay");
      } else {
        // User logged out, reset site selection if necessary
        this.selectedSite = "Tasman Bay";
        this.$store.dispatch("setSite", "Tasman Bay");
      }
    },
  },
};
</script>

<style scoped></style>